import { ParticipantType, RoleCode } from "../../types";

interface BroadcastConference {
  roomId: string;
  ownerId?: string;
  currHostUserId?: string;
  attendList?: ParticipantType[];
}

export function canHandleBroadcastLayout(
  conference: BroadcastConference,
  participants: ParticipantType[],
  operatorPeerId?: string
) {
  if (!operatorPeerId) return false;
  if (operatorPeerId === `${conference.roomId}_${conference.ownerId}`) return true;
  if (operatorPeerId === `${conference.roomId}_${conference.currHostUserId}`) return true;

  const onlinePeer = participants.find((p) => p.peerId === operatorPeerId);
  const offlinePeer = (conference.attendList || []).find((p) => p.peerId === operatorPeerId);
  const roleCode = (onlinePeer || offlinePeer)?.roleCode;

  return roleCode === RoleCode.host || roleCode === RoleCode.cohost;
}
